/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
/* eslint-disable no-process-env */

// IMPORTANT NOTE: All environment variables must start with "REACT_APP_" in order to be read
// Any other variables except NODE_ENV will be ignored.
// https://create-react-app.dev/docs/adding-custom-environment-variables

module.exports = {
  homepage: {
    default_locale: 'en',
    banner: "What's NEW? We're thrilled to unveil your personalized Trust experience!",
  },

  timeline: {
    limit: 33
  },

  footer: {
    userGuide: 'https://trust.salesforce.com/en/whats-new-trust/',
  },

  hyperforceDateWindow: process.env.HYPERFORCE_WINDOW_RELEASE_DAYS || 60,
};
